import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSync20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowSync20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.313 5.06c-2.728-.73-5.404.763-6.22 3.44h2.892a.75.75 0 1 1 0 1.5H3V5a.75.75 0 1 1 1.5 0v1.275c1.529-2.292 4.355-3.426 7.202-2.664a6.7 6.7 0 0 1 3.012 1.723.75.75 0 0 1-1.06 1.061 5.2 5.2 0 0 0-2.34-1.335m-2.622 9.885c2.728.73 5.404-.763 6.221-3.44H12.02a.75.75 0 0 1 0-1.5h4.985v5a.75.75 0 0 1-1.5 0V13.73c-1.528 2.293-4.354 3.427-7.201 2.664a6.7 6.7 0 0 1-3.013-1.722.75.75 0 0 1 1.06-1.062 5.2 5.2 0 0 0 2.341 1.335"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSync20);
